/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * max body width in % per viewport for the entry detail modal — only used by TPL_DEFAULT
 * @export
 * @interface DatabaseAppearancePropertiesDetailsBodyWidthPercent
 */
export interface DatabaseAppearancePropertiesDetailsBodyWidthPercent {
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearancePropertiesDetailsBodyWidthPercent
     */
    desktop?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearancePropertiesDetailsBodyWidthPercent
     */
    tablet?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearancePropertiesDetailsBodyWidthPercent
     */
    mobile?: number;
}

/**
 * Check if a given object implements the DatabaseAppearancePropertiesDetailsBodyWidthPercent interface.
 */
export function instanceOfDatabaseAppearancePropertiesDetailsBodyWidthPercent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAppearancePropertiesDetailsBodyWidthPercentFromJSON(json: any): DatabaseAppearancePropertiesDetailsBodyWidthPercent {
    return DatabaseAppearancePropertiesDetailsBodyWidthPercentFromJSONTyped(json, false);
}

export function DatabaseAppearancePropertiesDetailsBodyWidthPercentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAppearancePropertiesDetailsBodyWidthPercent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desktop': !exists(json, 'desktop') ? undefined : json['desktop'],
        'tablet': !exists(json, 'tablet') ? undefined : json['tablet'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
    };
}

export function DatabaseAppearancePropertiesDetailsBodyWidthPercentToJSON(value?: DatabaseAppearancePropertiesDetailsBodyWidthPercent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desktop': value.desktop,
        'tablet': value.tablet,
        'mobile': value.mobile,
    };
}

